export default __webpack_public_path__ + "static/media/14.dcbad0d0.webp";